import {formatCellValue as formatCellHelper} from "@/libs/helper/formatCellValue";
export const NeoOption: React.FC<any> = ({data, cellValue}) => {
  const booleanValue = formatCellHelper.formatYesNoOptions(cellValue);
  return (
    <div className="flex flex-col">
      <p className="text-bold text-small capitalize">
        {booleanValue ? "Yes" : "No"}
      </p>
    </div>
  );
};
